import { isa as __isa } from "@aws-sdk/smithy-client";
export var AppliedTerminology;
(function (AppliedTerminology) {
    AppliedTerminology.isa = function (o) {
        return __isa(o, "AppliedTerminology");
    };
})(AppliedTerminology || (AppliedTerminology = {}));
export var DeleteTerminologyRequest;
(function (DeleteTerminologyRequest) {
    DeleteTerminologyRequest.isa = function (o) {
        return __isa(o, "DeleteTerminologyRequest");
    };
})(DeleteTerminologyRequest || (DeleteTerminologyRequest = {}));
export var DescribeTextTranslationJobRequest;
(function (DescribeTextTranslationJobRequest) {
    DescribeTextTranslationJobRequest.isa = function (o) {
        return __isa(o, "DescribeTextTranslationJobRequest");
    };
})(DescribeTextTranslationJobRequest || (DescribeTextTranslationJobRequest = {}));
export var DescribeTextTranslationJobResponse;
(function (DescribeTextTranslationJobResponse) {
    DescribeTextTranslationJobResponse.isa = function (o) {
        return __isa(o, "DescribeTextTranslationJobResponse");
    };
})(DescribeTextTranslationJobResponse || (DescribeTextTranslationJobResponse = {}));
export var DetectedLanguageLowConfidenceException;
(function (DetectedLanguageLowConfidenceException) {
    DetectedLanguageLowConfidenceException.isa = function (o) {
        return __isa(o, "DetectedLanguageLowConfidenceException");
    };
})(DetectedLanguageLowConfidenceException || (DetectedLanguageLowConfidenceException = {}));
export var EncryptionKey;
(function (EncryptionKey) {
    EncryptionKey.isa = function (o) { return __isa(o, "EncryptionKey"); };
})(EncryptionKey || (EncryptionKey = {}));
export var EncryptionKeyType;
(function (EncryptionKeyType) {
    EncryptionKeyType["KMS"] = "KMS";
})(EncryptionKeyType || (EncryptionKeyType = {}));
export var GetTerminologyRequest;
(function (GetTerminologyRequest) {
    GetTerminologyRequest.isa = function (o) {
        return __isa(o, "GetTerminologyRequest");
    };
})(GetTerminologyRequest || (GetTerminologyRequest = {}));
export var GetTerminologyResponse;
(function (GetTerminologyResponse) {
    GetTerminologyResponse.isa = function (o) {
        return __isa(o, "GetTerminologyResponse");
    };
})(GetTerminologyResponse || (GetTerminologyResponse = {}));
export var ImportTerminologyRequest;
(function (ImportTerminologyRequest) {
    ImportTerminologyRequest.isa = function (o) {
        return __isa(o, "ImportTerminologyRequest");
    };
})(ImportTerminologyRequest || (ImportTerminologyRequest = {}));
export var ImportTerminologyResponse;
(function (ImportTerminologyResponse) {
    ImportTerminologyResponse.isa = function (o) {
        return __isa(o, "ImportTerminologyResponse");
    };
})(ImportTerminologyResponse || (ImportTerminologyResponse = {}));
export var InputDataConfig;
(function (InputDataConfig) {
    InputDataConfig.isa = function (o) {
        return __isa(o, "InputDataConfig");
    };
})(InputDataConfig || (InputDataConfig = {}));
export var InternalServerException;
(function (InternalServerException) {
    InternalServerException.isa = function (o) {
        return __isa(o, "InternalServerException");
    };
})(InternalServerException || (InternalServerException = {}));
export var InvalidFilterException;
(function (InvalidFilterException) {
    InvalidFilterException.isa = function (o) {
        return __isa(o, "InvalidFilterException");
    };
})(InvalidFilterException || (InvalidFilterException = {}));
export var InvalidParameterValueException;
(function (InvalidParameterValueException) {
    InvalidParameterValueException.isa = function (o) {
        return __isa(o, "InvalidParameterValueException");
    };
})(InvalidParameterValueException || (InvalidParameterValueException = {}));
export var InvalidRequestException;
(function (InvalidRequestException) {
    InvalidRequestException.isa = function (o) {
        return __isa(o, "InvalidRequestException");
    };
})(InvalidRequestException || (InvalidRequestException = {}));
export var JobDetails;
(function (JobDetails) {
    JobDetails.isa = function (o) { return __isa(o, "JobDetails"); };
})(JobDetails || (JobDetails = {}));
export var JobStatus;
(function (JobStatus) {
    JobStatus["COMPLETED"] = "COMPLETED";
    JobStatus["COMPLETED_WITH_ERROR"] = "COMPLETED_WITH_ERROR";
    JobStatus["FAILED"] = "FAILED";
    JobStatus["IN_PROGRESS"] = "IN_PROGRESS";
    JobStatus["STOPPED"] = "STOPPED";
    JobStatus["STOP_REQUESTED"] = "STOP_REQUESTED";
    JobStatus["SUBMITTED"] = "SUBMITTED";
})(JobStatus || (JobStatus = {}));
export var LimitExceededException;
(function (LimitExceededException) {
    LimitExceededException.isa = function (o) {
        return __isa(o, "LimitExceededException");
    };
})(LimitExceededException || (LimitExceededException = {}));
export var ListTerminologiesRequest;
(function (ListTerminologiesRequest) {
    ListTerminologiesRequest.isa = function (o) {
        return __isa(o, "ListTerminologiesRequest");
    };
})(ListTerminologiesRequest || (ListTerminologiesRequest = {}));
export var ListTerminologiesResponse;
(function (ListTerminologiesResponse) {
    ListTerminologiesResponse.isa = function (o) {
        return __isa(o, "ListTerminologiesResponse");
    };
})(ListTerminologiesResponse || (ListTerminologiesResponse = {}));
export var ListTextTranslationJobsRequest;
(function (ListTextTranslationJobsRequest) {
    ListTextTranslationJobsRequest.isa = function (o) {
        return __isa(o, "ListTextTranslationJobsRequest");
    };
})(ListTextTranslationJobsRequest || (ListTextTranslationJobsRequest = {}));
export var ListTextTranslationJobsResponse;
(function (ListTextTranslationJobsResponse) {
    ListTextTranslationJobsResponse.isa = function (o) {
        return __isa(o, "ListTextTranslationJobsResponse");
    };
})(ListTextTranslationJobsResponse || (ListTextTranslationJobsResponse = {}));
export var MergeStrategy;
(function (MergeStrategy) {
    MergeStrategy["OVERWRITE"] = "OVERWRITE";
})(MergeStrategy || (MergeStrategy = {}));
export var OutputDataConfig;
(function (OutputDataConfig) {
    OutputDataConfig.isa = function (o) {
        return __isa(o, "OutputDataConfig");
    };
})(OutputDataConfig || (OutputDataConfig = {}));
export var ResourceNotFoundException;
(function (ResourceNotFoundException) {
    ResourceNotFoundException.isa = function (o) {
        return __isa(o, "ResourceNotFoundException");
    };
})(ResourceNotFoundException || (ResourceNotFoundException = {}));
export var ServiceUnavailableException;
(function (ServiceUnavailableException) {
    ServiceUnavailableException.isa = function (o) {
        return __isa(o, "ServiceUnavailableException");
    };
})(ServiceUnavailableException || (ServiceUnavailableException = {}));
export var StartTextTranslationJobRequest;
(function (StartTextTranslationJobRequest) {
    StartTextTranslationJobRequest.isa = function (o) {
        return __isa(o, "StartTextTranslationJobRequest");
    };
})(StartTextTranslationJobRequest || (StartTextTranslationJobRequest = {}));
export var StartTextTranslationJobResponse;
(function (StartTextTranslationJobResponse) {
    StartTextTranslationJobResponse.isa = function (o) {
        return __isa(o, "StartTextTranslationJobResponse");
    };
})(StartTextTranslationJobResponse || (StartTextTranslationJobResponse = {}));
export var StopTextTranslationJobRequest;
(function (StopTextTranslationJobRequest) {
    StopTextTranslationJobRequest.isa = function (o) {
        return __isa(o, "StopTextTranslationJobRequest");
    };
})(StopTextTranslationJobRequest || (StopTextTranslationJobRequest = {}));
export var StopTextTranslationJobResponse;
(function (StopTextTranslationJobResponse) {
    StopTextTranslationJobResponse.isa = function (o) {
        return __isa(o, "StopTextTranslationJobResponse");
    };
})(StopTextTranslationJobResponse || (StopTextTranslationJobResponse = {}));
export var Term;
(function (Term) {
    Term.isa = function (o) { return __isa(o, "Term"); };
})(Term || (Term = {}));
export var TerminologyData;
(function (TerminologyData) {
    TerminologyData.isa = function (o) {
        return __isa(o, "TerminologyData");
    };
})(TerminologyData || (TerminologyData = {}));
export var TerminologyDataFormat;
(function (TerminologyDataFormat) {
    TerminologyDataFormat["CSV"] = "CSV";
    TerminologyDataFormat["TMX"] = "TMX";
})(TerminologyDataFormat || (TerminologyDataFormat = {}));
export var TerminologyDataLocation;
(function (TerminologyDataLocation) {
    TerminologyDataLocation.isa = function (o) {
        return __isa(o, "TerminologyDataLocation");
    };
})(TerminologyDataLocation || (TerminologyDataLocation = {}));
export var TerminologyProperties;
(function (TerminologyProperties) {
    TerminologyProperties.isa = function (o) {
        return __isa(o, "TerminologyProperties");
    };
})(TerminologyProperties || (TerminologyProperties = {}));
export var TextSizeLimitExceededException;
(function (TextSizeLimitExceededException) {
    TextSizeLimitExceededException.isa = function (o) {
        return __isa(o, "TextSizeLimitExceededException");
    };
})(TextSizeLimitExceededException || (TextSizeLimitExceededException = {}));
export var TextTranslationJobFilter;
(function (TextTranslationJobFilter) {
    TextTranslationJobFilter.isa = function (o) {
        return __isa(o, "TextTranslationJobFilter");
    };
})(TextTranslationJobFilter || (TextTranslationJobFilter = {}));
export var TextTranslationJobProperties;
(function (TextTranslationJobProperties) {
    TextTranslationJobProperties.isa = function (o) {
        return __isa(o, "TextTranslationJobProperties");
    };
})(TextTranslationJobProperties || (TextTranslationJobProperties = {}));
export var TooManyRequestsException;
(function (TooManyRequestsException) {
    TooManyRequestsException.isa = function (o) {
        return __isa(o, "TooManyRequestsException");
    };
})(TooManyRequestsException || (TooManyRequestsException = {}));
export var TranslateTextRequest;
(function (TranslateTextRequest) {
    TranslateTextRequest.isa = function (o) {
        return __isa(o, "TranslateTextRequest");
    };
})(TranslateTextRequest || (TranslateTextRequest = {}));
export var TranslateTextResponse;
(function (TranslateTextResponse) {
    TranslateTextResponse.isa = function (o) {
        return __isa(o, "TranslateTextResponse");
    };
})(TranslateTextResponse || (TranslateTextResponse = {}));
export var UnsupportedLanguagePairException;
(function (UnsupportedLanguagePairException) {
    UnsupportedLanguagePairException.isa = function (o) {
        return __isa(o, "UnsupportedLanguagePairException");
    };
})(UnsupportedLanguagePairException || (UnsupportedLanguagePairException = {}));
//# sourceMappingURL=index.js.map